import React from "react";
import * as ReactDOMServer from "react-dom/server";
import styles from "./Image.module.scss";

export default function Image(props) {
  const { src, alt, border = null, center = null, stretched = null } = props;
  return (
    <div
      className={`${styles.container} ${center && styles.center} ${
        stretched && styles.stretched
      }`}
    >
      <img
        loading="lazy"
        className={`${styles.image} ${border && styles.bordered}`}
        src={src}
        alt={alt}
      />
      {alt && <span className={styles.caption}>{alt}</span>}
    </div>
  );
}

export function renderImageComponent(props) {
  return ReactDOMServer.renderToString(<Image {...props} />);
}
